<template>
    <div>
        <CRow>
          <CCol col="12 col-sm-8">
            <CCard>
              <CCardBody>

                <CDataTableFixed
                    :items="items"
                    :fields="fields"

                    :items-per-page="20"
                    hover
                    sorter
                    pagination
                >

                  <template #row="{item}">

                    <td>
                      <p class="text-muted">{{item.id}}</p>

                    </td>

                  </template>
                  <template #name="{item}">

                    <td>
                      <p class="text-muted">{{item.title.name}}</p>

                    </td>

                  </template>
                  <template #summary="{item}">

                    <td>
                      <p class="text-muted">{{item.title.summary}}</p>

                    </td>

                  </template>
                  <template #link="{item}">

                    <td>
                      <p class="text-muted">{{item.link}}</p>

                    </td>

                  </template>
                  <template #priority="{item}">

                    <td>
                      <p class="text-muted">{{item.order_no}}</p>

                    </td>

                  </template>

                  <template #image="{item}">


                    <td>
                      <CImg width="50px" height="50px" v-bind:src="item.title.image"/>
                    </td>

                  </template>

                  <template #operation="{item}">
                    <td class="py-2">
                      <CButton
                          color="danger"
                          variant="outline"
                          square
                          size="sm"
                          @click="delete_item_dialog(item)"
                      ><CIcon name="cil-trash" size="sm"/>
                      </CButton>

                    </td>
                  </template>


                </CDataTableFixed>
              </CCardBody>

            </CCard>

          </CCol>
            <CCol col="12 col-sm-4">
                <CCard>
                    <CCardHeader>
                        <strong>{{ $t('add_image') }}</strong>

                    </CCardHeader>
                    <CCardBody>
                        <CRow>
                            <CCol col="12">
                                <CInput
                                    v-model="name"

                                    :label="$t('name')"
                                />
                            </CCol>
                        </CRow>
<!--                        <CRow>-->
<!--                            <CCol col="12">-->
<!--                                <CInput-->
<!--                                    v-model="summary"-->

<!--                                    :label="$t('slider_summary')"-->
<!--                                />-->
<!--                            </CCol>-->
<!--                        </CRow>-->
                        <CRow>
                            <CCol col="12">
                                <CInput
                                    v-model="order_no"

                                    :label="$t('priority')"
                                    placeholder="ترتیب"
                                />
                            </CCol>
                        </CRow>

                        <CRow>
                            <CCol col="12">
                                <CInput
                                    v-model="link"

                                    :label="$t('link')"
                                    placeholder="http://example.com"
                                />
                            </CCol>
                        </CRow>
                        <CRow>
                            <CCol col="4">
                              <ImageSelector :label="$t('image')"
                                             default_archive="sliders"
                                             :media_id.sync="file"

                                             :preview-image="previewImage"
                              />
                            </CCol>


                        </CRow>

                    </CCardBody>
                    <CCardFooter>
                        <CButton
                            @click="login()"
                            type="submit" ref="submit_form" size="sm" color="primary">
                            <CIcon name="cil-check-circle"/>
                          {{ $t('add_image') }}
                        </CButton>
                    </CCardFooter>
                </CCard>
            </CCol>

        </CRow>



    </div>

</template>

<script>
    import axios from "axios";
    import {bus} from "../../main";

    var items = [

    ];



    export default {
        name: 'Login',
        data() {
            return {
              confirm_delete_name:new Date().getTime()+"_"+this.$vnode.tag,

                link: '',
                name: '',
                file: null,
                summary: '',
                order_no: '',
                previewImage: null,
                description: '',
                selectedPosition: 1,
              fields : [
                {key: 'row',label: '#', _style: 'width:10%'},
                {key: 'name',label: this.$t('name'), _style: 'width:20%'},
                // {key: 'summary',label: this.$t('summary'), _style: 'width:20%'},
                // {key: 'link',label: this.$t('link'), _style: 'width:20%'},
                {key: 'image',label: this.$t('image'), _style: 'width:40%'},
                {key: 'priority',label: this.$t('priority'), _style: 'width:20%'},

                {key: 'operation',label: this.$t('operation'), _style: 'width:40%;'},


              ],
                selectPositions: [
                    {
                        value: 1,
                        label: 'چپ بالا'
                    },{
                        value: 2,
                        label: 'چپ وسط'
                    },{
                        value: 3,
                        label: 'چپ پایین'
                    },{
                        value: 4,
                        label: 'مرکز بالا'
                    },{
                        value: 5,
                        label: 'مرکز وسط'
                    },{
                        value: 6,
                        label: 'مرکز پایین'
                    },{
                        value: 7,
                        label: 'راست بالا'
                    },{
                        value: 8,
                        label: 'راست وسط'
                    },{
                        value: 9,
                        label: 'راست پایین'
                    },
                ],
                items: items.map((item, row_id) => {
                    return {...item, row_id}
                }),
                details: [],
                collapseDuration: 0,
                status_form: 0
            }
        }, mounted() {
            this.get_categories();
            bus.$on(this.confirm_delete_name, (data) => {
                // alert(data);
                if (data == 'true') {
                    this.delete_item();

                } else {
                    this.status_form = 0;
                }
            });
        }, watch: {
            '$route.params.slider_id': function (id) {
                this.get_categories();
            }
        },
        methods: {
         get_categories() {
                var self = this;
           var formData = new FormData()
formData.append("slider_id", this.$route.params.slider_id)
                axios.post('/api/admin/site/get_slider_images', formData,{}).then(function (response) {

                    var content_cats = response.data;

                    self.items = content_cats.orders.map((item, row_id) => {
                        return {...item, row_id}
                    });

                })
                    .catch(function (error) {

                        console.log(error);
                    });

            },
            login() {


                let self = this;
                const formData = new FormData()
                let url;
                url = "/api/admin/site/add_slider_images";

                formData.append('name', this.name);
                formData.append('summary', this.summary);
                formData.append('image', this.file);
                formData.append('link', this.link);
                formData.append('order_no', this.order_no);
                formData.append('slider_id', this.$route.params.slider_id);
                formData.append('text_position', this.selectedPosition);
                // formData.append('description', this.description)
                axios.post(url, formData, {}).then((res) => {


                    self.link = '';
                    self.name = '';
                    self.summary = '';
                    self.order_no = '';
                    self.previewImage = '';
                    self.get_categories();


                })

                    // axios.post(  '/admin/category', {
                    //     name: self.name,
                    //     description: self.description,
                    //     image: self.image,
                    //     cat: 0,
                    // }).then(function (response) {
                    //     self.name = '';
                    //     self.description = '';
                    //     // localStorage.setItem("api_token", response.data.access_token);
                    //     // self.$router.push({ path: 'notes' });
                    // })
                    .catch(function (error) {

                        console.log(error);
                    });

            },
          delete_item_dialog(item) {
                this.$root.modal_component.show_confirm_modal('اخطار',"آیا مایل به حذف این ردیف هستید؟",['تایید'],this.confirm_delete_name);

                this.status_form = item.id;

            },
            delete_item(){


                let self = this;
                const formData = new FormData()
                let url;
                url = "/api/admin/site/delete_slider_images";


                formData.append('id', this.status_form);

                axios.post(url, formData, {
                }).then((res) => {
                    if(res.data.error==1){
                        this.$root.modal_component.show_danger_modal('خطا',res.data.msg);

                    }else{
                        this.$root.modal_component.show_success_modal('تایید',res.data.msg);

                    }
                    self.status_form=0;

                    self.get_categories();


                })
                    .catch(function (error) {

                        console.log(error);
                    });
// this.get_categories();
                // this.$router.push({ path: '/posts/'});
            }
        }
    }


</script>
